import { createStyles } from "@mantine/core";

const useStyles = createStyles(() => ({
  drawer: {
    "& .mantine-Drawer-content": {
      borderRadius: "16px 0 0 16px",
    },
    "& .mantine-Drawer-header": {
      display: "none",
    },
    "& .mantine-Drawer-body": {
      padding: 0,
      height: "100%",
      display: "flex",
      flexDirection: "column",
    },
  },
  head: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    padding: "22px 28px",
    borderBottom: "1px solid #F3F4F6",
  },
  headTitle: {
    fontSize: 20,
    fontWeight: 700,
    fontFamily: "Inter",
    letterSpacing: "-0.015em",
    color: "#171717",
  },
  headSub: {
    fontSize: 13,
    color: "#667085",
    fontFamily: "Inter",
    marginTop: 3,
  },
  closeBtn: {
    width: 34,
    height: 34,
    borderRadius: 8,
    color: "#667085",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 18,
    "&:hover": { background: "#F4F4F5", color: "#171717" },
  },
  body: {
    flex: 1,
    overflowY: "auto",
    padding: "8px 28px 24px",
  },
  foot: {
    padding: "16px 28px",
    borderTop: "1px solid #E5E5E5",
    display: "flex",
    justifyContent: "space-between",
    gap: 10,
  },
  btnGhost: {
    height: 40,
    padding: "0 16px",
    borderRadius: 8,
    border: "1px solid #E5E5E5",
    background: "#fff",
    fontWeight: 600,
    fontSize: 13.5,
    fontFamily: "Inter",
    color: "#262626",
    "&:hover": { background: "#FAFAFA" },
  },
  btnAdd: {
    height: 40,
    padding: "0 18px",
    borderRadius: 8,
    background: "#FFAF4A",
    border: "1px solid #FFAF4A",
    fontWeight: 700,
    fontSize: 13.5,
    fontFamily: "Inter",
    color: "#171717",
    "&:hover": { background: "#F09E33" },
    "&:disabled": { opacity: 0.6, cursor: "not-allowed" },
  },
  section: {
    padding: "18px 0 6px",
    borderTop: "1px solid #F3F4F6",
    "&:first-of-type": { borderTop: "none" },
  },
  sectionLabel: {
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: ".08em",
    textTransform: "uppercase",
    color: "#667085",
    fontFamily: "Inter",
    marginBottom: 12,
  },
  choiceGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 12,
    "@media (max-width: 480px)": { gridTemplateColumns: "1fr" },
  },
  choiceCard: {
    textAlign: "left",
    border: "1.5px solid #E5E5E5",
    borderRadius: 12,
    padding: "14px 15px",
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: 11,
    cursor: "pointer",
    transition: "border-color .15s, background .15s",
    "&:hover": { borderColor: "#DDD6FE" },
  },
  choiceCardOn: {
    borderColor: "#53389E",
    background: "#F3F0FB",
  },
  choiceTop: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  choiceIcn: {
    width: 36,
    height: 36,
    borderRadius: 10,
    background: "#F4F4F5",
    display: "grid",
    placeItems: "center",
    color: "#53389E",
    flexShrink: 0,
  },
  choiceIcnOn: {
    background: "#fff",
  },
  choiceTitle: {
    fontSize: 14,
    fontWeight: 700,
    fontFamily: "Inter",
    color: "#171717",
  },
  choiceRadio: {
    marginLeft: "auto",
    position: "relative",
    width: 18,
    height: 18,
    borderRadius: "50%",
    border: "2px solid #9CA3AF",
    flexShrink: 0,
  },
  choiceRadioOn: {
    borderColor: "#53389E",
    "&::after": {
      content: '""',
      position: "absolute",
      inset: 3,
      borderRadius: "50%",
      background: "#53389E",
    },
  },
  hint: {
    marginTop: 8,
    padding: "10px 12px",
    borderRadius: 8,
    border: "1px solid #DDD6FE",
    background: "#F3F0FB",
    fontSize: 13,
    color: "#43307E",
    fontFamily: "Inter",
    display: "flex",
    gap: 8,
    alignItems: "flex-start",
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 14,
    "@media (max-width: 480px)": { gridTemplateColumns: "1fr" },
  },
  span2: { gridColumn: "1 / -1" },
  field: {
    "& label": {
      fontSize: 11.5,
      fontWeight: 600,
      textTransform: "uppercase",
      letterSpacing: ".03em",
      color: "#667085",
      fontFamily: "Inter",
      marginBottom: 6,
    },
    "& input, & textarea": {
      fontFamily: "Inter",
      fontSize: 13.5,
    },
  },
  psearch: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    height: 46,
    border: "1px solid #E5E5E5",
    borderRadius: 10,
    padding: "0 14px",
    color: "#9CA3AF",
    "&:focus-within": { borderColor: "#53389E" },
    "& input": {
      border: "none",
      outline: "none",
      flex: 1,
      background: "transparent",
      fontSize: 14,
      color: "#171717",
      fontFamily: "Inter",
    },
  },
  pempty: {
    marginTop: 10,
    border: "1px dashed #E5E5E5",
    borderRadius: 10,
    padding: "16px 14px",
    background: "#FAFAFA",
    fontSize: 13,
    color: "#667085",
    fontFamily: "Inter",
    textAlign: "center",
  },
  presultList: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    marginTop: 10,
  },
  presult: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    border: "1px solid #E5E5E5",
    borderRadius: 10,
    padding: "11px 14px",
    background: "#fff",
    cursor: "pointer",
    "&:hover": { background: "#FAFAFA", borderColor: "#DDD6FE" },
  },
  pav: {
    width: 38,
    height: 38,
    borderRadius: 10,
    background: "#F4F4F5",
    color: "#262626",
    display: "grid",
    placeItems: "center",
    fontSize: 12,
    fontWeight: 700,
    flexShrink: 0,
  },
  pname: {
    fontSize: 13.5,
    fontWeight: 600,
    color: "#171717",
    fontFamily: "Inter",
  },
  pmeta: {
    fontSize: 12,
    color: "#667085",
    fontFamily: "Inter",
    marginTop: 1,
  },
  paddLink: {
    fontSize: 12.5,
    fontWeight: 700,
    color: "#53389E",
    flexShrink: 0,
  },
  addBtnDashed: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    width: "100%",
    border: "1.5px dashed #E5E5E5",
    borderRadius: 10,
    padding: 11,
    fontSize: 13,
    fontWeight: 600,
    color: "#667085",
    background: "#fff",
    marginTop: 12,
    "&:hover": { borderColor: "#DDD6FE", color: "#53389E", background: "#F3F0FB" },
  },
  sentWrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: "38px 8px 8px",
  },
  sentIcon: {
    width: 96,
    height: 96,
    borderRadius: "50%",
    background: "#F0FDF4",
    display: "grid",
    placeItems: "center",
    color: "#15803D",
    marginBottom: 22,
  },
  sentTitle: {
    fontSize: 21,
    fontWeight: 700,
    letterSpacing: "-0.015em",
    color: "#171717",
    fontFamily: "Inter",
  },
  sentSub: {
    fontSize: 14,
    color: "#667085",
    lineHeight: 1.6,
    marginTop: 8,
    maxWidth: "44ch",
    fontFamily: "Inter",
  },
  sentCard: {
    width: "100%",
    marginTop: 24,
    border: "1px solid #E5E5E5",
    borderRadius: 12,
    background: "#FAFAFA",
    padding: "16px 18px",
    display: "flex",
    alignItems: "center",
    gap: 13,
    textAlign: "left",
  },
  sentAv: {
    width: 42,
    height: 42,
    borderRadius: 11,
    background: "#F3F0FB",
    color: "#43307E",
    display: "grid",
    placeItems: "center",
    fontSize: 13,
    fontWeight: 800,
    flexShrink: 0,
  },
  sentName: {
    fontSize: 14.5,
    fontWeight: 700,
    color: "#171717",
    fontFamily: "Inter",
  },
  sentMail: {
    fontSize: 12.5,
    color: "#667085",
    marginTop: 2,
    fontFamily: "Inter",
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  // "Ogiso" tag on the pending provider's card — same pill as the provider
  // list's Type column so the two read as the same label.
  sentPill: {
    display: "inline-flex",
    alignItems: "center",
    textTransform: "uppercase",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: ".05em",
    padding: "4px 12px",
    borderRadius: 999,
    border: "1px solid #BFDBFE",
    background: "#EFF6FF",
    color: "#1D4ED8",
    fontFamily: "Inter",
  },
  sentNext: {
    width: "100%",
    marginTop: 20,
    textAlign: "left",
  },
  sentNextLbl: {
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: ".08em",
    textTransform: "uppercase",
    color: "#667085",
    marginBottom: 10,
    fontFamily: "Inter",
  },
  sentStep: {
    display: "flex",
    alignItems: "flex-start",
    gap: 11,
    padding: "9px 0",
    fontSize: 13.5,
    color: "#262626",
    lineHeight: 1.5,
    fontFamily: "Inter",
  },
  sentStepNum: {
    width: 21,
    height: 21,
    borderRadius: "50%",
    background: "#F4F4F5",
    color: "#262626",
    fontSize: 11,
    fontWeight: 800,
    display: "grid",
    placeItems: "center",
    flexShrink: 0,
    marginTop: 1,
  },
}));

export default useStyles;
